module.exports = __webpack_public_path__ + "static/media/OEM-LOGOS.4905f147.png";